/**
 * Product type filter values are translated (Rings / Bagues), so switching
 * language or market via Selecty keeps a value unknown to the new locale.
 * When the value is unknown, we look for the language it belongs to (hreflang
 * alternates), grab a product of that type there, and read its type back in
 * the current locale through `/products/<handle>.js`.
 */
(() => {
  const PARAM = 'filter.p.product_type'
  const GRID_ID = 'CollectionProductGrid'

  const getAvailableValues = (root = document) =>
    [...root.querySelectorAll(`input[name="${PARAM}"]`)].map((input) => input.value).filter(Boolean)

  const getFirstProductHandle = (root = document) => {
    const link = root.querySelector(`#${GRID_ID} a[href*="/products/"]`)
    const match = link && link.getAttribute('href').match(/\/products\/([^/?#]+)/)
    return match ? match[1] : null
  }

  // One URL per other language (bare hreflang like "en" / "fr")
  const getAlternateUrls = () => {
    const currentLocale = (window.Shopify && window.Shopify.locale) || document.documentElement.lang
    return [...document.querySelectorAll('link[rel="alternate"][hreflang]')]
      .filter((link) => /^[a-z]{2}$/.test(link.hreflang) && link.hreflang !== currentLocale)
      .map((link) => link.href)
  }

  const findHandleInOtherLanguages = async (value) => {
    const section = document.getElementById(GRID_ID)?.closest('.shopify-section')
    const sectionId = section && section.id.replace('shopify-section-', '')
    if (!sectionId) return null

    for (const alternate of getAlternateUrls()) {
      // Keep path only: stays same-origin (local dev server, preview domains)
      const url = new URL(new URL(alternate).pathname, window.location.origin)
      url.searchParams.set(PARAM, value)
      url.searchParams.set('section_id', sectionId)

      try {
        const response = await fetch(url)
        if (!response.ok) continue
        const html = new DOMParser().parseFromString(await response.text(), 'text/html')
        if (!getAvailableValues(html).includes(value)) continue
        const handle = getFirstProductHandle(html)
        if (handle) return handle
      } catch (e) {}
    }
    return null
  }

  const translate = async (value) => {
    const handle = await findHandleInOtherLanguages(value)
    if (!handle) return null

    try {
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'
      const response = await fetch(`${root}products/${handle}.js`)
      if (!response.ok) return null
      const product = await response.json()
      return getAvailableValues().includes(product.type) ? product.type : null
    } catch (e) {
      return null
    }
  }

  const fix = async () => {
    const url = new URL(window.location.href)
    const value = url.searchParams.get(PARAM)
    if (!value) return

    const available = getAvailableValues()
    if (available.includes(value)) return
    // Filter not rendered on this page: only act when the grid is empty
    if (!available.length && getFirstProductHandle()) return

    const translated = await translate(value)
    if (translated) {
      url.searchParams.set(PARAM, translated)
    } else {
      url.searchParams.delete(PARAM)
    }
    url.searchParams.delete('page')
    window.location.replace(url.toString())
  }

  fix()
})()
